module.exports = __webpack_public_path__ + "img/yeti.b7709ade.svg";